import RowingHeroSection from '../components/template/rosemary/rowingHeroSection'
import AsymmetricFlow from '../components/template/rosemary/asymmetricFlow'
import PromotionalLead from '../components/template/rosemary/promotionalLead'
import PassimCarve from '../components/template/rosemary/passimCarve'
import PassimCarvePlayer from '../components/template/rosemary/passimCarvePlayer'
import InventorySlide from '../components/template/rosemary/inventorySlide'
import RowingHeroSectionPlayer from '../components/template/rosemary/rowingHeroSectionPlayer'
import BohemiaBanner from '../components/template/rosemary/bohemiaBanner'
import ClassyBanners from '../components/template/fitness/classyBanners'
import NarrowAdmonition from '../components/template/fitness/narrowAdmonition'
import DefinityCards from '../components/template/fitness/definityCards'
import FineTunedGallery from '../components/template/fitness/fineTunedGallery'
import FineTunedGalleryIkim from '../components/template/fitness/fineTunedGalleryIkim'
import FlyerIntro from '../components/template/fitness/flyerIntro'
import MementoSlides from '../components/template/fitness/mementoSlides'
import WedgedInfo from '../components/template/fitness/wedgedInfo'
import ClassBannerPlayer from '../components/template/fitness/classBannerPlayer'
import ArtistMax from '../components/template/fitness/artistMax'
import DecomposedBanners from '../components/template/gaming/decomposedBanners'
import DecomposedBannersPlayer from '../components/template/gaming/decomposedBannersPlayer'
import ExtensiveCarouselRendition from '../components/template/gaming/extensiveCarouselRendition'
import AdNCarousel from '../components/template/gaming/adNCarousel'
import AdNCarouselPlayer from '../components/template/gaming/adNCarouselPlayer'
import ExtensiveCarouselSimple from '../components/template/gaming/extensiveCarouselSimple'
import TripleCardCarousel from '../components/template/gaming/tripleCardCarousel'
import BobbingCards from '../components/template/gaming/bobbingCards'
import GloamingBannerSwimlane from '../components/template/gaming/gloamingBannerSwimlane'
import DefaultBanner from '../components/template/default/defaultBanner'
import DefaultBannerPlayer from '../components/template/default/defaultBannerPlayer'
import DefaultSwimlane from '../components/template/default/defaultSwimlane'
import NewDefaultSwimlane from '../components/template/default/newDefaultSwimlane'
import DefaultArtistSwimlane from '../components/template/default/defaultArtistSwimlane'
import DefaultVenueSwimlane from '../components/template/default/defaultVenueSwimlane'
import AudioSwimlane from '../components/template/default/audioSwimlane'
import ListenLoungeCards from '../components/template/default/listenLoungeCards'
import TopTenSwimlane from '../components/template/default/topTenSwimlane'
import ArticleText from '../components/template/default/articleText'
import ArticleImage from '../components/template/default/articleImage'
import CategorySlider from '../components/template/default/categorySlider'
import ContentGrid from '../components/template/default/contentGrid'
import PortraitOwlCarousel from '../components/template/default/portraitOwlCarousel'
import ProfileMediaPlayer from '../components/template/default/profileMediaPlayer'
import SectionalComponentWithAd from '../components/template/default/sectionalComponentWithAd'
import SportsSwimlane from '../components/template/default/sportsSwimlane'
import SportsPromotionalBlock from '../components/template/default/sportsPromotionalBlock'
import SportsFragmentedBanner from '../components/template/default/sportsFragmentedBanner'
import InteriorSquare from '../components/template/default/interiorSquare'
import ProductFaceCardCarousel from '../components/template/eCommerce/productFaceCardCarousel'
import UnikornsCardCarousel from '../components/template/eCommerce/unikornsCardCarousel'
import MicroSpeciesCardCarousel from '../components/template/eCommerce/mircoSpeciesCardCarousel'
import EventCoverBanner from '../components/template/eCommerce/eventCoverBanner'
import QuadruplePromoCarousel from '../components/template/eCommerce/quadruplePromoCarousel'
import TemplateCustomForms from '../components/template/templateCustomForms/index'
import continueWatchingSwimlane from '../components/template/default/continueWatchingSwimlane'
import NewInventorySlide from '../components/template/rosemary/newInventorySlide'
import ShortReelSwimlane from '../components/template/default/shortReelSwimlane'
import DecomposedBannersSwimlane from '../components/template/gaming/decomposedBannersSwimlane'
import IkimBanner from '../components/template/ikim/ikimBanner'
import IkimBannerCardCarousel from '../components/template/ikim/ikimBannerCardCarousel'
import defaultSwimlane3 from '../components/template/default/defaultSwimlane3'
import UnikornsCardCarouselPricing from '../components/template/eCommerce/unikornsCardCarouselPricing'
import ExtensiveCarouselCenterAligned from '../components/template/gaming/extensiveCarouselCenterAligned'
import ProductFaceCardCarouselDynamic from '../components/template/eCommerce/productFaceCardCarouselDynamic'
import broadcastHubCards from '../components/template/gaming/broadcastHubCards'
import smoothHorizonCards from '../components/template/default/smoothHorizonCards'
import VerticalSpotlightCards from '../components/template/default/verticalSpotlightCards'
import MediaFeaturePanel from '../components/template/rosemary/mediaFeaturePanel'
import FocusFrame from '../components/template/default/focusFrame'
import EliteTenCarousel from '../components/template/default/eliteTenCarousel'
import CenterStageCardCarousel from '../components/template/fitness/centerStageCardCarousel'
import showcaseSplit from '../components/template/gaming/showcaseSplit'
import PanoramaCarousel from '../components/template/default/panoramaCarousel'
import VerticalStreamDeck from '../components/template/default/verticalStreamDeck'
import HoverPeekCarousel from '../components/template/default/hoverPeekCarousel'
import staggeredCardCarousel from '../components/template/rosemary/staggeredCardCarousel'
import BreakingInsightsCarousel from '../components/template/ikim/breakingInsightsCarousel'
import CategoryNavigatorCards from '../components/template/default/categoryNavigatorCards'
import CategoryNavigator from '../components/template/default/categoryNavigator'
import SectionalComponentWithAd2 from '../components/template/default/sectionalComponentWithAd2'
import VerticalStreamSectionalComponent from '../components/template/default/verticalStreamSectionalComponent'

export const ComponentConfig = {
  rowingHeroSection: RowingHeroSection,
  asymmetricFlow: AsymmetricFlow,
  promotionalLead: PromotionalLead,
  passimCarve: PassimCarve,
  passimCarvePlayer: PassimCarvePlayer,
  inventorySlide: InventorySlide,
  classyBanners: ClassyBanners,
  classyBannersPlayer: ClassBannerPlayer,
  categoryBanners: CategorySlider,
  narrowAdmonition: NarrowAdmonition,
  definityCards: DefinityCards,
  fineTunedGallery: FineTunedGallery,
  fineTunedGalleryIkim: FineTunedGalleryIkim,
  flyerIntro: FlyerIntro,
  mementoSlides: MementoSlides,
  wedgedInfo: WedgedInfo,
  decomposedBanners: DecomposedBanners,
  decomposedBannersPlayer: DecomposedBannersPlayer,
  extensiveCarouselRendition: ExtensiveCarouselRendition,
  adNCarousel: AdNCarousel,
  adNCarouselPlayer: AdNCarouselPlayer,
  extensiveCarousel: ExtensiveCarouselSimple,
  tripleCardCarousel: TripleCardCarousel,
  bobbingCards: BobbingCards,
  defaultBanner: DefaultBanner,
  defaultBannerPlayer: DefaultBannerPlayer,
  defaultSwimlane: DefaultSwimlane,
  newDefaultSwimlane: NewDefaultSwimlane,
  audioSwimlane: AudioSwimlane,
  artistSwimlane: DefaultArtistSwimlane,
  venueSwimlane: DefaultVenueSwimlane,
  topTenSwimlane: TopTenSwimlane,
  articleText: ArticleText,
  articleImage: ArticleImage,
  contentGrid: ContentGrid,
  portraitOwlCarousel: PortraitOwlCarousel,
  customForm: TemplateCustomForms,
  gloamingBannerSwimlane: GloamingBannerSwimlane,
  profileMedia: ProfileMediaPlayer,
  sectionalComponentWithAd: SectionalComponentWithAd,
  sportsSwimlane: SportsSwimlane,
  sportsPromotionalBlock: SportsPromotionalBlock,
  sportsFragmentedBanner: SportsFragmentedBanner,
  rowingHeroSectionPlayer: RowingHeroSectionPlayer,
  bohemiaBanner: BohemiaBanner,
  artistMax: ArtistMax,
  artistMaxPlayer: ArtistMax,
  artistMaxWithoutText: ArtistMax,
  interiorSquare: InteriorSquare,
  productFaceCard: ProductFaceCardCarousel,
  productFaceCardDynamic: ProductFaceCardCarouselDynamic,
  unikornsCardCarousel: UnikornsCardCarousel,
  microSpeciesCardCarousel: MicroSpeciesCardCarousel,
  eventCoverBannerCarousel: EventCoverBanner,
  quadruplePromoCarousel: QuadruplePromoCarousel,
  continueWatching: continueWatchingSwimlane,
  newInventorySlide: NewInventorySlide,
  shortReelSwimlane: ShortReelSwimlane,
  decomposedBannersSwimlane: DecomposedBannersSwimlane,
  ikimBanner: IkimBanner,
  newDefaultSwimlane2: defaultSwimlane3,
  unikornsCardCarouselPricing: UnikornsCardCarouselPricing,
  extensiveCarouselCenter: ExtensiveCarouselCenterAligned,
  ikimBannerCardCarousel: IkimBannerCardCarousel,
  broadcastHubCards: broadcastHubCards,
  smoothHorizonCards: smoothHorizonCards,
  verticalSpotlightCards: VerticalSpotlightCards,
  mediaFeaturePanel: MediaFeaturePanel,
  focusFrame: FocusFrame,
  eliteTencarousel: EliteTenCarousel,
  centerStageCardCarousel: CenterStageCardCarousel,
  showcaseSplit: showcaseSplit,
  panoramaCarousel: PanoramaCarousel,
  verticalStreamDeck: VerticalStreamDeck,
  hoverPeekCarousel: HoverPeekCarousel,
  listenLoungeCards: ListenLoungeCards,
  staggeredCardCarousel: staggeredCardCarousel,
  breakingInsightsCarousel: BreakingInsightsCarousel,
  categoryNavigatorCards: CategoryNavigatorCards,
  categoryNavigator: CategoryNavigator,
  sectionalComponentWithAd2: SectionalComponentWithAd2,
  verticalStreamSectionalComponent: VerticalStreamSectionalComponent,
}
